import { SVGProps } from 'react';

const SvgListChecked = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
        <path d="M10.453 13.551 8.4 11.311l.866-.866 1.187 1.187 2.68-2.68.867 1.053M7.317 13.55H1.493A1.488 1.488 0 0 1 0 12.058V1.605C0 .775.665.11 1.493.11h10.454c.829 0 1.493.665 1.493 1.494v5.824a4.469 4.469 0 0 0-1.493-.538V1.605H1.493v10.453H6.78c.09.538.276 1.038.537 1.493Zm-.597-2.986H2.987V9.07H6.72m2.001-1.493H2.987V6.085h7.466v.806a4.399 4.399 0 0 0-1.732.687Zm1.732-2.987H2.987V3.098h7.466" />
    </svg>
);
export default SvgListChecked;
